import { NumberCellTemplate } from "@silevis/reactgrid";
import ContextMenuCellWrapper from "./ContextMenuCellWrapper";
import HighlightCell from "./HighlightCell";
import { useState } from "react";

export class CustomNumberCellTemplate {
    constructor() {
        this.base = new NumberCellTemplate();
    }

    getStyle() {
        return {
            overflow: "visible",
        };
    }

    getCompatibleCell(cell) {
        return this.base.getCompatibleCell(cell);
    }

    update(cell, cellToMerge) {
        return this.base.update(cell, cellToMerge);
    }

    render(cell, isInEditMode, onCellChanged) {
        return (
            <NumberCell
                base={this.base}
                isInEditMode={isInEditMode}
                onCellChanged={onCellChanged}
                cell={cell}
            />
        );
    }
}

const NumberCell = ({ base, isInEditMode, onCellChanged, cell }) => {
    const [hover, setHover] = useState(false);
    const handleMouseEnter = () => {
        setHover(true);
    };
    const handleMouseLeave = () => {
        setHover(false);
    };
    return (
        <ContextMenuCellWrapper cell={cell}>
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    justifyContent: "right",
                    alignItems: "center",
                    display: "flex",
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {base.render(cell, isInEditMode, onCellChanged)}
                <HighlightCell hover={hover} cell={cell} />
            </div>
        </ContextMenuCellWrapper>
    );
};
